import api from '@/utils/api';

/**
 * Export dealer prices
 * @param {string} dealerId Dealer id
 * @param {object} exportData - The export (price_type) data
 * @returns {Promise}
 */
const exportDealerPriceApi = (dealerId, exportData) =>
  api.post(`/dealer/${dealerId}/price/export`, exportData);

export default exportDealerPriceApi;
